import { render, staticRenderFns } from "./multilingual-add.vue?vue&type=template&id=d4dbdbc6&scoped=true"
import script from "./multilingual-add.vue?vue&type=script&lang=js"
export * from "./multilingual-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dbdbc6",
  null
  
)

export default component.exports